export default "__VITE_ASSET__a4b9a2e6__"